import React, { Component } from "react"
import { media, styled } from "./mediaCSS"
import Img from "gatsby-image"
import { Link, StaticQuery, graphql } from "gatsby"
import { FaBars, FaPhoneSquare, FaTimes } from "react-icons/fa"
import SocialLinks from "./socialLinks"

const MobileHeaderContainer = styled.header`
  display: flex;
  flex-direction: column;
  background: #1f599b;

  ${media.mobilePWA`
    display: none;
  `}

  ${media.tablet_desktop`
    display: none;
  `}
`

const MobileMenuContainer = styled.menu`
  &.isOpen {
    max-height: 600px;
    padding: 20px 10px 20px 10px;
    transition: max-height 0.5s linear;
  }

  &.isClosed {
    max-height: 0px;
    padding: 0px 10px 0px 10px;
    transition: max-height 0.25s linear;
    transition: padding 0.25s linear;
  }

  padding-inline-start: 0px;
  margin-block-start: 0px;
  margin-block-end: 0px;

  max-height: 0px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  > a {
    background: #111111;
    color: white;
    font-weight: 900;
    text-decoration: none;
    border-radius: 5px;
    font-size: 18px;
    padding: 15px 20px 15px 20px;
    margin: 5px;

    &.active {
      background: #ffffff;
      color: #111111;
    }
  }
`

const MobileTopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 3.75rem;

  .mobileButton {
    padding: 8px;
  }

  .mobileButtonTel {
    padding: 8px;
    color: white;
    font-size: 45px;
    margin-top: 10px;
  }

  #menuMobileBars.show {
    display: block;
  }

  #menuMobileBars.hide {
    display: none;
  }

  #menuMobileCloseIcon.hide {
    display: none;
  }

  #menuMobileCloseIcon.show {
    display: block;
  }
`

class MobileHeader extends Component {
  toggleMenu() {
    const mobileMenu = document.getElementById("mobileMenu")

    if (mobileMenu.classList.contains("isClosed")) {
      mobileMenu.classList.replace("isClosed", "isOpen")
      document
        .getElementById("menuMobileCloseIcon")
        .classList.replace("hide", "show")

      document
        .getElementById("menuMobileBars")
        .classList.replace("show", "hide")
    } else {
      mobileMenu.classList.replace("isOpen", "isClosed")
      document
        .getElementById("menuMobileCloseIcon")
        .classList.replace("show", "hide")

      document
        .getElementById("menuMobileBars")
        .classList.replace("hide", "show")
    }
  }

  render() {
    return (
      <MobileHeaderContainer>
        <MobileTopBar>
          <FaBars
            id="menuMobileBars"
            className="mobileButton show"
            onClick={() => {
              this.toggleMenu()
            }}
          ></FaBars>
          <FaTimes
            onClick={() => {
              this.toggleMenu()
            }}
            id="menuMobileCloseIcon"
            className="mobileButton hide"
          ></FaTimes>

          <Link style={{ height: "85px" }} title="Home" to="/">
            <StaticQuery
              query={graphql`
                query {
                  logo: file(relativePath: { eq: "logo.png" }) {
                    childImageSharp {
                      fixed(height: 85) {
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              `}
              render={data => (
                <Img
                  className="topLogo"
                  fixed={data.logo.childImageSharp.fixed}
                />
              )}
            />
          </Link>
          <a
            key="phone"
            rel="noopener noreferrer"
            aria-label="Place Call"
            href={`tel://817-665-5454`}
            className="mobileButtonTel"
          >
            <FaPhoneSquare />
          </a>
        </MobileTopBar>
        <MobileMenuContainer id="mobileMenu" className="isClosed">
          <Link activeClassName="active" to="/">
            Home
          </Link>
          <Link activeClassName="active" to="/menu/">
            Menu
          </Link>
          {/* <Link activeClassName="active" to="/drinks/">
            Drinks
          </Link> */}
          <Link activeClassName="active" to="/specials/">
            Specials
          </Link>
          <Link activeClassName="active" to="/events/">
            Live Music
          </Link>
          <Link activeClassName="active" to="/location/">
            Location
          </Link>
          <Link activeClassName="active" to="/catering/">
            Catering
          </Link>
          <Link activeClassName="active" to="/shuttle/">
            Shuttle
          </Link>

          <Link activeClassName="active" to="/photos/">
            Photos
          </Link>
          <Link activeClassName="active" to="/staff/">
            Staff
          </Link>
          <Link activeClassName="active" to="/messages/">
            Messages
          </Link>
          <Link activeClassName="active" to="/contact/">
            Contact Us
          </Link>

          <SocialLinks />
        </MobileMenuContainer>
      </MobileHeaderContainer>
    )
  }
}

export default MobileHeader
